"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Flex = void 0;
var react_1 = __importDefault(require("react"));
var components_1 = require("../components");
var Align_1 = require("./Align");
var Customize_1 = require("./Customize");
var Justify_1 = require("./Justify");
var Flex = function () { return (react_1.default.createElement(components_1.Doc, { title: "Flex" },
    react_1.default.createElement(Align_1.AlignItems, null),
    react_1.default.createElement(Justify_1.JustifyContent, null),
    react_1.default.createElement(Customize_1.FlexCustomize, null))); };
exports.Flex = Flex;
